<template>
  <b-card class="bg-white rounded-xl px-4 eventss">
    <el-drawer
      :title="`${this.action} Future Trends`"
      :visible.sync="drawer"
      :direction="direction"
      :before-close="handleClose"
    >
      <ValidationObserver
        tag="form"
        ref="obs1"
        @submit.prevent="addFutureTrendsData()"
        class="bg-white h-100"
      >
        <div class="px-5 pt-4">
          <div class="mt-4">
            <label class="fsize16 text-dark font-semibold">Cover Image</label><br>
            <div
              class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
            >
              Recommended Size: 800 × 500px
            </div>
            <FileUploader
              v-show="!coverimage_image"
              :image="coverimage_image"
              :onSuccess="coverimage_handleSuccess"
              class="w-full my-1 m-auto display-none custmodal"
            />
            <div v-if="action != 'Edit'">
              <img
                v-if="coverimage_image"
                :src="coverimage_image"
                ref="cover"
                class="w-full my-1 m-auto display-none custmodal"
              />
              <div
                class="flex justify-center text-red"
                v-if="coverimage_image"
                @click="coverimage_handleRemove"
              >
                Remove image
              </div>
            </div>
            <div v-else>
              <img
                v-if="coverimage_image"
                :src="
                  coverimage_image.slice(0, 4) === 'data'
                    ? coverimage_image
                    : `${$imageURL}/${coverimage_image}`
                "
                ref="cover"
                class="w-full my-1 m-auto display-none custmodal"
              />
              <div
                class="text-center text-red"
                v-if="coverimage_image"
                @click="coverimage_handleRemove"
              >
                Edit image
              </div>
            </div>
          </div>
          <p class="fsize12 text-danger" v-if="coverimage_showValidationErr">
            {{ coverimage_validationErr }}
          </p>

          <div class="mt-4">
            <label class="fsize16 text-dark font-semibold"
              >Select File Type</label
            >
            <ValidationProvider
              name="FileType"
              rules="required"
              v-slot="{ errors }"
            >
              <el-select
                v-model="fileTypeSelected"
                placeholder="Select"
                class="mt-1 w-full"
                :disabled="action == 'Edit'"
              >
                <el-option
                  v-for="item in fileTypeOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="">
            <label
              v-if="action == 'Edit'"
              class="fsize16 text-dark font-semibold"
              >{{ fileTypeSelected }}</label
            >
            <label v-else class="fsize16 text-dark font-semibold"
              >Document/Image/Video/Url</label
            >
            <!-- Image -->
            <div v-if="fileTypeSelected == 'Image'">
              <FileUploader
                v-show="!image"
                :image="image"
                :onSuccess="handleSuccess"
                class="w-full my-1 m-auto display-none custmodal"
              />
              <div v-if="action != 'Edit'">
                <img
                  v-if="image"
                  :src="image"
                  ref="cover"
                  class="w-full my-1 m-auto display-none custmodal"
                />
                <div
                  class="flex justify-center text-red"
                  v-if="image"
                  @click="handleRemove"
                >
                  Remove image
                </div>
              </div>
              <div v-else>
                <img
                  v-if="image"
                  :src="
                    image.slice(0, 4) === 'data'
                      ? image
                      : `${$imageURL}/${image}`
                  "
                  ref="cover"
                  class="w-full my-1 m-auto display-none custmodal"
                />
                <div
                  class="text-center text-red"
                  v-if="image"
                  @click="handleRemove"
                >
                  Edit image
                </div>
              </div>
            </div>

            <!-- Document -->
            <div v-if="fileTypeSelected == 'Document'">
              <FileUploader
                v-show="!image"
                :image="image"
                :onSuccess="handleSuccess"
                class="w-full my-1 m-auto display-none custmodal"
              />

              <div v-if="action != 'Edit'">
                <p>{{ fileName }}</p>

                <div
                  class="flex justify-center text-red"
                  v-if="image"
                  @click="handleRemove"
                >
                  Remove
                </div>
              </div>
              <div v-else>
                <p>{{ image }}</p>
                <feather-icon
                  v-if="image"
                  @click="openDoc()"
                  icon="ExternalLinkIcon"
                  svgClasses="w-4 h-4 text-blue-500 cursor-pointer"
                ></feather-icon>
                <div
                  class="text-center text-red"
                  v-if="image"
                  @click="handleRemove"
                >
                  Edit
                </div>
              </div>
            </div>

            <!-- Video -->
            <div v-if="fileTypeSelected == 'Video'">
              <FileUploader
                v-show="!image"
                :image="image"
                :onSuccess="handleSuccess"
                class="w-full my-1 m-auto display-none custmodal"
              />
              <div v-if="action != 'Edit'">
                <video
                  v-if="image"
                  autoplay
                  controls
                  :src="image"
                  class="w-full"
                />
                <div
                  class="flex justify-center text-red"
                  v-if="image"
                  @click="handleRemove"
                >
                  Remove Video
                </div>
              </div>
              <div v-else>
                <video
                  v-if="image"
                  autoplay
                  controls
                  :src="
                    image.slice(0, 4) === 'data'
                      ? image
                      : `${$imageURL}/${image}`
                  "
                  ref="cover"
                  class="rounded-full widtht20percent m-auto display-none custmodal"
                />
                <div
                  class="text-center text-red"
                  v-if="image"
                  @click="handleRemove"
                >
                  Edit Video
                </div>
              </div>
            </div>

            <!-- Url -->
            <div v-if="fileTypeSelected == 'Url'">
              <ValidationProvider
                name="Url"
                rules="required"
                v-slot="{ errors }"
              >
                <el-input
                  placeholder="Please input"
                  class="w-full"
                  v-model="selectedUrl"
                ></el-input>
                <span class="fsize12 text-danger">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>

            <span
              v-if="imageErr"
              class="flex justify-center small text-danger"
              >{{ msg.image }}</span
            >
            <p class="fsize12 text-danger" v-if="showValidationErr">
              {{ validationErr }}
            </p>
          </div>

          <div class="mt-4">
            <label class="fsize16 text-dark font-semibold">Title</label>
            <ValidationProvider
              name="Title"
              rules="required"
              v-slot="{ errors }"
            >
              <el-input
                placeholder="Please input"
                class="w-full"
                v-model="selectedTitle"
              ></el-input>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="mt-4">
            <label class="fsize16 text-dark font-semibold">Description</label>
            <ValidationProvider
              name="Description"
              rules="required"
              v-slot="{ errors }"
            >
              <el-input
                placeholder="Please input"
                class="w-full"
                type="textarea"
                v-model="selectedDesp"
              ></el-input>
              <span class="fsize12 text-danger">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>

          <div class="mt-5 flex justify-center">
            <base-button
              outline
              @click="
                action == 'Add' ? addFutureTrendsData() : editFutureTrendsData()
              "
              class="px-8 fsize14 py-2 mx-1"
              type="primary"
            >
              Submit
            </base-button>
          </div>
        </div>
      </ValidationObserver>
    </el-drawer>

    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">Future Trends</h2>
      </div>
      <base-button
        outline
        class="px-6 py-1 mx-1"
        type="primary"
        @click="actionPerform('', 'Add')"
      >
        <span class="btn-inner--text flex justify-between items-center"
          ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon> Add
          Future Trends
        </span>
      </base-button>
    </div>
    <div class="mt-5">
      <b-input-group class="">
        <b-form-input
          class="border-none shadow-lg"
          type="text"
          min="0.00"
          v-model="search"
          placeholder="Enter Search...."
          v-on:input="searchBy"
        ></b-form-input>

        <b-input-group-append>
          <b-button
            variant="white"
            class="flex items-center shadow-lg"
            aria-label="search"
          >
            <feather-icon
              class="cursor-pointer mr-2"
              icon="SearchIcon"
              svgClasses="w-4 h-4"
            ></feather-icon>
          </b-button>
        </b-input-group-append>
      </b-input-group>

      <el-table
        class="table-responsive table-flush mt-6"
        header-row-class-name="thead-light table-th-color"
        :data="tableData"
        border
      >
        <el-table-column
          label="Title"
          min-width="200px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="fsize14 text-dark">{{ row.title }}</p>
          </template>
        </el-table-column>

        <el-table-column
          label="File Type"
          min-width="200px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="fsize14 text-dark">{{ row.fileType }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="Document/Image/Video/Url"
          min-width="200px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <!-- Image -->
            <div v-if="row.fileType == 'Image'">
              <img
                v-if="row.hasOwnProperty('file') && row.file != ''"
                :src="`${$imageURL}/${row.file}`"
                :alt="image"
              />
              <img
                v-else
                :src="`${$imageURL}/caregiversaathi/default/dummy%20image.jpg`"
                :alt="image"
              />
            </div>

            <!-- Video -->
            <div v-if="row.fileType == 'Video'">
              <video
                v-if="row.hasOwnProperty('file') && row.file != ''"
                :src="`${$imageURL}/${row.file}`"
              />

              <p v-else>No Video Avaliable</p>
            </div>

            <!-- Documnet -->
            <div v-if="row.fileType == 'Document'">
              {{
                row.hasOwnProperty("file") ? row.file : "No Document Avaliable"
              }}
            </div>

            <!-- Url -->
            <div v-if="row.fileType == 'Url'">
              {{ row.hasOwnProperty("url") ? row.url : "No Url Avaliable" }}
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Description"
          min-width="200px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="fsize14 text-dark">{{ row.description }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="Created Date"
          min-width="250px"
          prop="heading"
          class="ml-12"
          sortable
        >
          <template v-slot="{ row }">
            <p class="font-semibold text-left name mb-0 text-sm">
              {{ getDate(row.createdAt) }}
            </p>
          </template>
        </el-table-column>
        <el-table-column
          label="Actions"
          min-width="100px"
          class-name="text-center"
        >
          <template v-slot="{ row }">
            <div class="flex justify-center items-center gap-1">
              <feather-icon
                @click="actionPerform(row, 'Edit')"
                icon="EditIcon"
                svgClasses="w-4 h-4 text-blue-500 cursor-pointer"
              ></feather-icon>
              <feather-icon
                @click="deleteFutureTrendsData(row)"
                icon="Trash2Icon"
                svgClasses="w-4 h-4 text-red-600 cursor-pointer"
              ></feather-icon>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="mt-5 flex justify-end">
      <el-pagination
        @current-change="
          (value) => {
            currentPage = value;
            getFutureTrendsData();
          }
        "
        layout="prev,pager,next"
        :per-size="10"
        :total="pageCount"
      >
      </el-pagination>
    </div>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";
import moment from "moment";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
extend("required", {
  ...rules.required,
  message: "This field is required",
});
extend("integer", {
  ...rules.integer,
  message: "This field must be an integer",
});
export default {
  data() {
    return {
      drawer: false,

      direction: "rtl",

      search: "",
      tableData: [],

      // add/edit initiative
      action: "",
      selectedId: "",
      selectedItem: "",

      fileTypeSelected: "",
      fileTypeOptions: ["Document", "Url", "Image", "Video"],

      selectedTitle: "",
      selectedDesp: "",
      selectedUrl: "",

      // pagination
      currentPage: 1,
      pageCount: 0,

      // image
      showValidationErr: false,
      validationErr: "This field is required",
      fileName: "",
      image: null,
      coverImage: null,
      imageErr: false,
      msg: {
        image: "",
      },

      // cover image
      coverimage_showValidationErr: false,
      coverimage_validationErr: "This field is required",
      coverimage_image: null,
      coverimage_coverImage: null,
      coverimage_imageErr: false,
      coverimage_msg: {
        image: "",
      },
    };
  },

  methods: {
    searchBy: _.debounce(function (e) {
      this.getFutureTrendsData();
    }, 500),

    getDate(date) {
      return moment(date).format("MMMM Do YYYY, h:mm a");
    },
    async getFutureTrendsData() {
      let offset = 0;
      let payload = {
        pagination: true,
      };

      if (this.currentPage == 1) {
        Object.assign(payload, { offset: offset });
      } else {
        offset = 10 * this.currentPage - 10;
        Object.assign(payload, { offset: offset });
      }
      if (this.search != "") {
        Object.assign(payload, { search: this.search });
      }
      let result = await this.$store.dispatch("ffc/getFutureTrends", payload);
      console.log(result, "RESULT");
      this.tableData = result.data.data;
      this.pageCount = result.data.count;
    },
    clearAll() {
      this.action = "";
      this.selectedId = "";
      this.selectedItem = "";

      this.selectedTitle = "";
      this.selectedDesp = "";
      this.selectedUrl = "";

      this.fileTypeSelected = "";
      this.image = "";
      this.coverImage = "";

      this.coverimage_image = null;
      this.coverimage_coverImage = null;
    },
    handleClose() {
      this.drawer = false;
      this.clearAll();
    },
    actionPerform(VALUE, ACTION) {
      if (ACTION == "Add") {
        this.drawer = true;
        this.action = ACTION;
      } else if (ACTION == "Edit") {
        console.log(VALUE, "VALUE");
        this.drawer = true;
        this.action = ACTION;
        this.selectedItem = VALUE;
        this.selectedId = VALUE._id;

        this.fileTypeSelected = VALUE.hasOwnProperty("fileType")
          ? VALUE.fileType
          : "";

        this.selectedTitle = VALUE.hasOwnProperty("title") ? VALUE.title : "";

        this.selectedDesp = VALUE.hasOwnProperty("description")
          ? VALUE.description
          : "";
        this.selectedUrl = VALUE.hasOwnProperty("url") ? VALUE.url : "";
        this.image = VALUE.hasOwnProperty("file") ? VALUE.file : "";
        this.coverimage_image = VALUE.hasOwnProperty("coverImage")
          ? VALUE.coverImage
          : "";
      }
    },
    async addFutureTrendsData() {
      if (
        this.fileTypeSelected != "Url" &&
        (this.image == "" || this.image == null)
      ) {
        this.showValidationErr = true;
      } else {
        this.showValidationErr = false;
      }
      if (this.coverimage_image == "" || this.coverimage_image == null) {
        this.coverimage_showValidationErr = true;
      } else {
        this.coverimage_showValidationErr = false;
      }
      this.$refs.obs1.validate().then(async (success) => {
        if (success) {
          // if (this.image != "" && this.coverImage != "") {
          const payload = new FormData();

          payload.append("title", this.selectedTitle);
          payload.append("description", this.selectedDesp);
          payload.append("url", this.selectedUrl);

          payload.append("fileType", this.fileTypeSelected);
          payload.append("file", this.coverImage);
          payload.append("coverImage", this.coverimage_coverImage);
          let result = await this.$store.dispatch(
            "ffc/addFutureTrends",
            payload
          );
          this.coverImage = "";
          this.image = "";

          this.coverimage_image = null;
          this.coverimage_coverImage = null;
          // } else {
          //   let payload = {};
          //   if (this.selectedTitle != "") {
          //     Object.assign(payload, { title: this.selectedTitle });
          //   }
          //   if (this.selectedDesp != "") {
          //     Object.assign(payload, { description: this.selectedDesp });
          //   }
          //   if (this.selectedUrl != "") {
          //     Object.assign(payload, { url: this.selectedUrl });
          //   }
          //   if (this.fileTypeSelected != "") {
          //     Object.assign(payload, { fileType: this.fileTypeSelected });
          //   }
          //   let result = await this.$store.dispatch(
          //     "ffc/addFutureTrends",
          //     payload
          //   );
          // }
          await this.clearAll();
          await this.handleClose();
          await this.getFutureTrendsData();
        }
      });
    },
    async editFutureTrendsData() {
      const payload = new FormData();
      payload.append("_id", this.selectedId);
      if (
        this.selectedItem.hasOwnProperty("title") &&
        this.selectedTitle != this.selectedItem.title
      ) {
        payload.append("title", this.selectedTitle);
      }

      if (
        this.selectedItem.hasOwnProperty("description") &&
        this.selectedDesp != this.selectedItem.description
      ) {
        payload.append("description", this.selectedDesp);
      }

      if (
        this.selectedItem.hasOwnProperty("url") &&
        this.selectedUrl != this.selectedItem.url
      ) {
        payload.append("url", this.selectedUrl);
      }

      if (
        this.selectedItem.hasOwnProperty("fileType") &&
        this.fileTypeSelected != this.selectedItem.fileType
      ) {
        payload.append("fileType", this.fileTypeSelected);
      }

      if (
        this.selectedItem.hasOwnProperty("file") &&
        this.image != this.selectedItem.file
      ) {
        payload.append("file", this.coverImage);
      }

      if (
        this.selectedItem.hasOwnProperty("coverImage") &&
        this.coverimage_image != this.selectedItem.coverImage
      ) {
        payload.append("coverImage", this.coverimage_image);
      }

      let result = await this.$store.dispatch("ffc/editFutureTrends", payload);
      await this.clearAll();
      await this.handleClose();
      await this.getFutureTrendsData();
    },
    async deleteFutureTrendsData(ITEM) {
      let result = await this.$store.dispatch("ffc/deleteFutureTrends", {
        _id: ITEM._id,
        isDeleted: true,
      });
      await this.getFutureTrendsData();
    },
    handleSuccess(image) {
      console.log(image, "UPLOADED FIEL");
      this.fileName = image.name;
      // let mByte = 5 * 1048576;
      // if (image.size > mByte) {
      //   this.$swal.fire({
      //     title: "File size exceeds the allowed limit!",
      //     // text: "Please ensure that the file size does not exceed 5MB",
      //     html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
      //     confirmButtonText: "Okay",
      //     icon: "warning",
      //     confirmButtonColor: "#830c81",
      //     showCancelButton: false,
      //   });
      //   return;
      // }
      this.imageErr = false;
      if (this.fileTypeSelected == "Image" && !image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else if (
        this.fileTypeSelected == "Video" &&
        !image.type.includes("video")
      ) {
        this.imageErr = true;
        this.msg.image = "Upload Video Only";
      } else if (
        this.fileTypeSelected == "Document" &&
        !image.type.includes("pdf")
      ) {
        this.imageErr = true;
        this.msg.image = "Upload PDF Only";
      } else {
        this.imageErr = false;
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));
        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    coverimage_readerData(rawFile) {
      let loader = this.$loading();
      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.coverimage_image = e.target.result));
        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.fileName = "";
      this.coverImage = null;
    },
    coverimage_handleSuccess(image) {
      this.coverimage_imageErr = false;
      this.coverimage_coverImage = image;
      this.coverimage_readerData(image);
    },
    coverimage_handleRemove() {
      this.coverimage_image = null;
      this.coverimage_coverImage = null;
    },
  },
  async mounted() {
    await this.getFutureTrendsData();
  },
  components: {
    FileUploader,
    ValidationObserver,
    ValidationProvider,
    rules,
    extend,
  },
  watch: {
    drawer(value) {
      if (value == false) {
        this.clearAll();
        this.$refs["obs1"].reset();
        this.$refs["obs1"].resetValidation();
      }
    },
    image(value) {
      if (value != "" && value != null) {
        this.showValidationErr = false;
      }
    },
    coverimage_image(value) {
      if (value != "" && value != null) {
        this.coverimage_showValidationErr = false;
      }
    },
  },
};
</script>
